import FormikInputField from 'components/common/Fields/FormikInputField';
import PayorCodeList from 'components/PayorCodeList';
import { Formik } from 'formik';
import React, { useState } from 'react'
import HoverImage from 'react-hover-image/build';
import ReactInputMask from 'react-input-mask';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import Tooltip from "react-tooltip-lite";

import Question from 'assets/icon/icons8-question-mark.svg'
import save from "assets/icon/save.svg";
import cancel from "assets/icon/cancel.svg";
import plus from "assets/icon/plus-icon.svg";
import useAxios from 'hooks/useAxios';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import DatePicker from 'react-datepicker';
import Calendar from "assets/icon/calendar-icon.svg";
import { ModuleAccess } from 'utils/moduleaccess';
import moment from 'moment';
import { dateFormate } from 'utils/columns';
import { toast } from "react-toastify";
import ReactSelect from 'react-select';
import { Option, LimitedChipsContainer } from 'components/Options';
import useContextService from 'hooks/useContextService';

let coveredEntityError = "Covered Entity is a required field";

let addpayorData = {};
let hasDatePopupOpen = false;
let ceIds = [];
const AddPayor = (props) => {
  const { orgId, key, fetchPayorTable, addpayorflag, setAddpayorflag, handelAddpayor, search, payortableData, coveredEntitiesData,ceFlag,parentceIDs,handlereset } = props;

  const API = useAxios()
  const [tableData, setTableData] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [payorDisc, setPayorDisc] = useState('');
  const [payorcode, setPayorCode] = useState('');
  const [showAddPayor, setShowPayor] = useState(true);
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [addpayor, setAddPayor] = useState("");
  const [provider, setProvider] = useState('');
  const [payorname, setAddpayorName] = useState("");
  const [payorBlock, setAddpayorBlock] = useState("");
  const [errorMessage, setErrorMessage] = useState('')
  const [effectivedate, setEffectiveDate] = useState("");
  const [addpayorerr, setAddPayorerr] = useState("");
  const [addpayornameerr, setAddPayornameerr] = useState("");
  const [dateerror, setDateError] = useState("");
  const [payorcodeerror, setPayorCodeError] = useState("");
  const [totalrecords, setTotalReocrds] = useState([])
  const [currentRowData, setCurrentRowData] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [active, setActive] = useState('N');
  const [hasInteracted, setHasInteracted] = useState(false);
  const [originalData, setOriginalData] = useState({});
  const [ishiddenflag, setIshiddenflag] = useState(false);
  const [savebuttondisable, setSavebuttondisable] = useState(false);
  const [hasCESelected, setCESelected] = useState(true);
  const [selectedCEOption, setCEOptionSelected] = useState({
    optionCESelected: "-1",
  });
 const {
    states: { configAddPayorType },
    setStates,
    resetStates
  } = useContextService();
  const {searchTerms} = configAddPayorType;

  const toggle = () => setModal(!modal);
  const onSelect = async (payorcode) => {
    if (payorcode) {
      setProvider(payorcode);
      setPayorCode(payorcode.code);
      if (payorcode?.code?.length > 0) {
        setPayorCodeError("");
      } else {
        setPayorCodeError("Payer Code is a required field");
      }
      setSavebuttondisable(false);
    } else {
      setPayorCode('');
      setProvider('');
      setSavebuttondisable(false);
    }

  };

  const handleStartDate = (effectivedate) => {
    let stDate = dateFormate(effectivedate);
    setEffectiveDate(stDate);
    addpayorData.effectivedate = moment(new Date(effectivedate)).format('MM/DD/YY');
    if (stDate) {
      setDateError("");
    }
    else {
      setDateError("Effective Date is a required field");
    }
    setSavebuttondisable(false);
  };

  const handleStartDateRaw = (e) => {
    var valdt = new Date();
    var val = e.target.value;
    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    //setHasInteracted(true);
    if (!val || isValid == false || val < valdt) {
      addpayorData.effectivedate = null;
      setEffectiveDate(null);
      // if (hasInteracted) {
      //   setDateError("Effective Date is a required field");
      // }
    } else if (isValid && val >= valdt) {
      handleStartDate(e.target.value);
    }

  };
  // const checkValidation = () => {
  //   debugger
  //   setSavebuttondisable(true);
  //   if (ceFlag == true) {
  //     ceIds = configAddPayorType.searchTerms.coveredEntityIDs.map(item => item["value"]);
  //     if (ceIds.length == 0) {
  //       setSavebuttondisable(false);
  //       setCESelected(false);
  //     }
  //   }
  //   if (payorname?.length == 0) {
  //     setAddPayornameerr("Payor Name is a required field");
  //     setSavebuttondisable(false);
  //   }
  //   if (effectivedate == 0 || effectivedate == null) {
  //     setDateError("Effective Date is a required field");
  //     setSavebuttondisable(false);
  //   }
  //   if (payorcode?.length == 0 || provider.code?.length == 0) {
  //     setPayorCodeError("Payor Code is a required field");
  //     setSavebuttondisable(false);
  //   }
  //   if (payorcode?.length > 0 && effectivedate?.length > 0 && payorname?.length > 0) {
  //     toggle();
  //   }
  // }
  const checkValidation = () => {
  debugger;
      ceIds = [];
  
  // 1. Reset error states immediately
  setAddPayornameerr("");
  setDateError("");
  setPayorCodeError("");
  setCESelected(true);

  // 2. Pre-calculate validation checks for cleaner logic
    if (ceFlag == true) {
      ceIds = configAddPayorType.searchTerms.coveredEntityIDs.map(item => item["value"]);
    }
  const isCeInvalid = ceFlag && (!configAddPayorType?.searchTerms?.coveredEntityIDs?.length);
  const isPayorNameInvalid = !payorname?.trim();
  const isEffectiveDateInvalid = !effectivedate; // Catches null, undefined, 0, or empty string
  const isPayorCodeInvalid = !payorcode?.trim();;

  // 3. Determine if the entire form is invalid
  const isFormInvalid = isCeInvalid || isPayorNameInvalid || isEffectiveDateInvalid || isPayorCodeInvalid;

  if (isFormInvalid) {
    // 4. Trigger specific error states
    if (isCeInvalid) setCESelected(false);
    if (isPayorNameInvalid) setAddPayornameerr("Payor Name is a required field");
    if (isEffectiveDateInvalid) setDateError("Effective Date is a required field");
    if (isPayorCodeInvalid) setPayorCodeError("Payor Code is a required field");
    
    setSavebuttondisable(false);
    return; // Exit early if validation fails
  }

  // 5. Success path
  setSavebuttondisable(true);
  toggle();
};
  const handleSubmit = async () => {
debugger;
    let payload = {};
    payload.PayorTypeCode = payorcode.trim();
    payload.PayorTypeDesc = payorname;
    payload.PayorBlock = payorBlock;
    payload.InactiveFlag = "Y";
    payload.EffectiveDate = moment(new Date(effectivedate)).format('YYYY-MM-DD');
    if(ceIds.length > 0  && ceFlag == true){
      payload.CEIDS = ceIds;
    }
    else{
      payload.CEIDS = [];
    }
    //AddPayerEntityList.push(payload);

    if (payorcode?.length > 0 && payorname?.length > 0 && effectivedate) {
      try {
        const result = await API.post(`SBTenant/${orgId.tenantID}/Configuration/AddPayer`,  payload,

          {
            hasDefaultURL: true,
            hideLoader: true,
          }
        );
       

        if (result) {
          if (result?.data == false) {
            setErrorMessage("This Payor configuration already exists");
          }
          else {

            if (ceFlag && parentceIDs.length === 0) {
              handlereset();
            } else {
              fetchPayorTable(search);
            }
            toast.success("Payor Added Successfully");
            setAddpayorflag(false)
            configAddPayorType.searchTerms.coveredEntityIDs = [];
            updateStates(configAddPayorType);
            handelCancel();
          }
          setLoading(false);
        }

      } catch (error) {
        console.log(error);
        setLoading(false);
        setSavebuttondisable(false);
      }
    }
  };
  const handelPayorname = ({ target: { value } }) => {
    setAddpayorName(value);
    if (value?.length > 0) {
      setAddPayornameerr("");
    }
    if (value?.length == 0) {
      setAddPayornameerr("Payor Name is a required field");
    }
    setSavebuttondisable(false);
    addpayorData.payorname = value
  }
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const hasPermission = (code) => {
    return ModuleAccess("CON", code);

  }
  const handelPayorBlock = (event) => {

    setAddpayorBlock(event.target.value);

  }
  const handelCancel = () => {
    setAddPayor('');
    setAddpayorName("");
    setEffectiveDate("");
    setAddPayornameerr("");
    setDateError("");
    setErrorMessage("");
    setPayorCode('');
    setProvider('');
    setSavebuttondisable(false);
    // setcollapseSider(true)
  };
  const handlePayorcode = (e) => {
    debugger;
    if(e.target.value != ""){
      setPayorCodeError("")
    }
    setPayorCode(e.target.value)

  }
//  const handleCoverdEntityChange = (selected, setFieldValue, entity) => {
//   debugger;
//     if (selected) {
//       setCESelected(true);
//       setCEOptionSelected({
//         optionCESelected: selected
//       });
//       ceIds.push(selected[0].value);
//     }
//     else {
//  setCEOptionSelected({
//         optionCESelected: "-1"
//       });
//  setCESelected(false);

//        //ceIds.pop(selected[0].value);
//     }
 
//   };
const handleCoverdEntityChange = (selected, setFieldValue, entity) => {
    // let selected = [selectedces == null ? []: selectedces]

    if (selected) {
    
      setCESelected(true);
      setCEOptionSelected({
        optionCESelected: selected.value
      });
      let val = selected.value;
      configAddPayorType.coveredEntities = selected;
      // setFieldValue('coveredEntityIDs', selected);
      configAddPayorType.searchTerms.coveredEntityIDs = selected;
      // if (Array.isArray(configAddPayorType.searchTerms.coveredEntityIDs)) {
      //   // accumulationIDs = {};
      //   configAddPayorType.searchTerms.accumulationIDs = {};
      // }
      updateStates(configAddPayorType);

    }
    else {

      configAddPayorType.coveredEntities = [];
      configAddPayorType.searchTerms.coveredEntityIDs = {};
      setCESelected(false);
    }
    updateStates(configAddPayorType);
  };
  const updateStates = (configAddPayorType) => {
    setStates("configAddPayorType", configAddPayorType);
  };
  return (
    <div>
      <div className={""}>
        <Card hidden={""} className='border-0 shadow-top'>
          <CardBody>
            <Formik
              // initialValues={initialValues}
              onSubmit={handleSubmit}
              // validationSchema={validationSchema}
              enableReinitialize={true}
              children={(props) => {
                //    const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touche } = props;
                return (
                  <div hidden={collapseSider}>
                    <h5 className="f-15 text-primary font-weight-700">
                      Add Payor Type
                    </h5>
                    <Row>
                      <Col md={3} lg={3} sm={6} xs={6} hidden={ceFlag == false}  >
                        {' '}
                        <FormGroup className='ce-reports'>
                          <Label for='coveredentity'>Covered Entity</Label>
                          <ReactSelect
                            name='coveredentity'
                            id='coveredentity'
                            options={coveredEntitiesData}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            optionSelected={true}
                            isClearable={true}
                            components={{
                              Option, ValueContainer: LimitedChipsContainer,
                            }}
                            isSearchable="true"
                            onChange={(value, cp) =>
                              handleCoverdEntityChange(value, cp)}
                            value={selectedCEOption.optionCESelected}
                            className='claim_info required'
                            maxMenuHeight={220}
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 99,
                              }),
                              option: (provided) => ({
                                ...provided,
                                display: 'flex',
                                alignItems: 'flex-start',
                              })
                            }}
                          />
                        </FormGroup>
                         {!hasCESelected ? (
                            <div className="text-danger font-size-12">
                              {coveredEntityError}
                            </div>
                          ) : ""}
                      </Col>
                      <Col md={3}>
                        {" "}

                        <FormGroup>
                          <Label for="Payor Code">Payor Code</Label>

                          <div className="d-flex">
                            {/* <PayorCodeList tenantID={orgId?.tenantID}
                                onSelect={onSelect}
                                selectedProvider={provider} /> */}
                            <Input type='text' name='payorcode' onChange={handlePayorcode} placeholder='Enter Payor Code' className='required' maxLength={255} />
                            <div style={{ marginTop: 5, marginLeft: 10 }} hidden={true}>
                              <Tooltip
                                content={
                                  <div className="tip-list-info"
                                  >
                                    <p>
                                      <strong>
                                        Payor Code :{" "}
                                      </strong>
                                      <br />
                                      <br />
                                      <span>
                                        Entering a minimum of 2 characters will
                                        auto-populate a list of Payor Codes observed in
                                        the processed Drug Utilization File(s) that are
                                        not already configured in the table. Initial
                                        results are limited to 10 Payor Codes. If the
                                        Payor Code is not auto-populated in the first 10
                                        results then enter more characters.
                                        <br />
                                        <br />
                                        If adding a Payor Code proactively, please check
                                        the table to see if the value already exists, if
                                        not, after typing in the Payor Code value and no
                                        results found, proceed with entering in the Payor
                                        Name, Effective Date and hit save.
                                        <br />
                                        <br />
                                        NOTE: The proactive Payor Code entered that was
                                        not found in the search, must be the exact value
                                        that will be processed in the Drug Utilization
                                        File(s).    </span>
                                    </p>
                                  </div>
                                }
                                direction="right"
                                tagName="span"
                                className="target"
                                tipContentClassName=""
                                zIndex={99999}
                              >
                                <span className="cursor-pointer text-decoration-underline">
                                  <HoverImage
                                    src={Question}
                                    hoverSrc={Question}
                                    style={{ width: '20px', height: '20px' }}
                                  ></HoverImage>
                                </span>
                              </Tooltip>
                            </div>
                          </div>
                        </FormGroup>
                        {payorcodeerror && (
                          <div className="text-danger font-size-12">
                            {payorcodeerror}
                          </div>
                        )}
                      </Col>
                      <Col md={3}>
                        {" "}
                        <FormGroup>
                          <Label for="payorname">Payor Name</Label>
                          <Input
                            id="payorname"
                            name="payorname"
                            type="text"
                            className="required"
                            placeholder="Enter Payor Name"
                            autoComplete="off"
                            value={payorname}
                            component={FormikInputField}
                            onChange={handelPayorname}
                          />
                        </FormGroup>
                        {addpayornameerr && (
                          <div className="text-danger font-size-12">
                            {addpayornameerr}
                          </div>
                        )}
                      </Col>
                      <Col md={2}>
                        {" "}
                        <FormGroup>
                          <Label for="payorblock">Payor Block</Label>
                          <Input
                            id="payorblock"
                            name="payorblock"
                            type="select"
                            // className="required"
                            //placeholder="Enter Payor Name"
                            autoComplete="off"
                            value={payorBlock}
                            //component={FormikInputField}
                            onChange={handelPayorBlock}
                          >
                            <option value={''}>--select--</option>
                            <option value="Y">Y</option>
                            <option value="N">N</option>

                          </Input>
                        </FormGroup>
                        {/* {payorBlock == "" && (
                            <div className="text-danger font-size-12">
                              {addpayornameerr}
                            </div>
                          )} */}
                      </Col>
                      <Col md={ceFlag == true ? 3 : 2} className="required-date">
                        {" "}
                        <FormGroup>
                          <Label for="effectivedate">Effective Date</Label>
                          <InputGroup onMouseLeave={handleMouseLeave}>
                            <DatePicker
                              id="effectivedate"
                              name="effectivedate"
                              selected={effectivedate}
                              onChange={(e) => { handleStartDate(e) }}
                              onChangeRaw={handleStartDateRaw}
                              dateFormat="MM/dd/yyyy"
                              placeholderText='Select a date'
                              autoComplete='off'
                              customInput={
                                <ReactInputMask mask="99/99/9999"
                                  value={effectivedate}
                                />
                              }
                            />
                            <InputGroupText
                              onClick={() => handleDateClick("effectivedate")}
                            >
                              <img src={Calendar} alt="" />
                            </InputGroupText>
                          </InputGroup>

                        </FormGroup>
                        {dateerror && (
                          <div className="text-danger font-size-12">
                            {dateerror}
                          </div>
                        )}
                      </Col>
                      <Col
                        md={2}
                        className="d-flex"
                        style={{ paddingTop: "34px" }}
                      >
                        <div style={{ marginRight: 10 }}>
                          <Tooltip
                            content={
                              <div className="tip-list-info"
                              >
                                <p>
                                  <strong>
                                    Effective Date :{" "}
                                  </strong>
                                  <br />
                                  <br />
                                  <span>
                                    The Effective Date entered determines if the
                                    Utilizations with a Drug Administration Date on/after
                                    is eligible for 340B or when the Payor should be
                                    blocked with Payor Exclusion reason.
                                    <br />
                                    <br />
                                    Note: If Payor
                                    Code should have been excluded all time, the calendar
                                    will allow you to go back to the live date configured
                                    in our system.    </span>
                                </p>
                              </div>
                            }
                            direction="right"
                            tagName="span"
                            className="target"
                            tipContentClassName=""
                            zIndex={99999}
                          >
                            <span className="cursor-pointer text-decoration-underline">
                              <HoverImage
                                src={Question}
                                hoverSrc={Question}
                                style={{ width: '20px', height: '20px' }}
                              ></HoverImage>
                            </span>
                          </Tooltip>
                        </div>
                        {/* <FormGroup>
                            <Label for="active">Active</Label>
                            <Input
                              id="active"
                              name="active"
                              type="checkbox"
                              autoComplete="off"
                              checked={active}
                              //onChange={handleCheckbox}
                              disabled
                              style={{
                                marginLeft: "5px",
                                fontSize: "18px",
                                marginTop: "2px",
                              }}
                            />
                          </FormGroup> */}
                      </Col>
                    </Row>
                    <Row style={{ justifyContent: "flex-end" }}>
                      <Col
                        sm={3}
                        className="d-flex"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <Label>{""}</Label>
                        <Button
                          // disabled={isSubmitting}
                          // disabled={(addpayor.length==0 && payorname.length==0 && effectivedate.length==0)}
                          color="primary"
                          className="search"
                          onClick={checkValidation}
                          //disabled = {savebuttondisable}
                          hidden={!hasPermission("ED")}
                        >
                          <span className="right_5">
                            <img src={save} alt="" />
                          </span> Save
                        </Button>
                        <Button
                          color="primary"
                          className="reset"
                          onClick={handelAddpayor}
                        >
                          <span className="right_5">
                            <img src={cancel} alt="" />
                          </span> Cancel
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6}>
                        {errorMessage ? (
                          <div
                            style={{
                              display: "inline-block",
                              backgroundColor: "#ffe6e6",
                              // padding: "5px",
                            }}
                            className="text-danger f-12"
                          >
                            {errorMessage}
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                  </div>
                );
              }}
            ></Formik>
          </CardBody>
        </Card>
        <div>
          <Modal isOpen={modal} toggle={toggle} className="custom-modal">
            <ModalHeader className="modal-header-primary" toggle={toggle}>
              Add Payor
            </ModalHeader>
            <ModalBody className="custom-modal-body" height="">
              {payortableData.length != 0 ?

                (<><p>Confirm that you would like to make this Payor Code configuration change.</p>
                  <p>Payor Code : {payorcode} </p>
                  <p>Effective Date: {dateFormate(effectivedate)}</p>
                  <p>
                    NOTE: All Utilizations with a Drug Administration Date on/or after the New Effective Date (Past and Present)
                    will go through an auto-reprocess the same day. Future Effective Dates do not require a reprocess
                  </p>
                </>) : (
                  <><p>When adding Payor Codes to your configurations, you are confirming that these Payor Codes are not eligible for 340B.</p>
                    <p>Payor Code : {payorcode} </p>
                    <p>Effective Date: {dateFormate(effectivedate)}</p>
                    <p>
                      NOTE: All Utilizations with a Drug Administration Date on/or after the New Effective Date (Past and Present)
                      will go through an auto-reprocess the same day. Future Effective Dates do not require a reprocess
                    </p>
                  </>
                )
              }
            </ModalBody>
            <ModalFooter>
              <Button color="primary" className="modal-button" onClick={() => { toggle(); handleSubmit(); }} >OK</Button>
              <Button color="primary" className="modal-button" onClick={toggle}>Cancel</Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    </div>
  )
}

export default AddPayor